import { Button } from '@calendly/ui/components/button';
import { Modal } from '@calendly/ui/components/modal';
import { Header, Title } from '@calendly/ui/components/popup';
import { Sheet } from '@calendly/ui/components/sheet';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { etEditorOverlayZIndex } from 'shared/modal_stacking';
import { eventTypeSelector, membershipsWithSlugConflictSelector } from '../selectors';
const popupContainerCss = "p1rp9zo2";
const PopupContainer = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(popupContainerCss, props.className)} />);
const footerCss = "f1lrtmq6";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, props.className)} />;
});
const cancelButtonCss = "cx72e95";
const CancelButton = forwardRef((props, ref) => {
  const decoration = 'ghost';
  return <Button ref={ref} {...props} decoration={decoration} className={classNames(cancelButtonCss, props.className)} />;
});
export const SlugConflictPopup = ({
  isOpen,
  title,
  content: Content,
  submitButtonText,
  cancelButtonText,
  onSubmit,
  onClose
}) => {
  const {
    slug
  } = useSelector(eventTypeSelector);
  const memberships = useSelector(membershipsWithSlugConflictSelector);
  return <Modal isOpen={isOpen} onClose={onClose} zIndex={etEditorOverlayZIndex}>
      <PopupContainer>
        <Header>
          <Title>{title}</Title>
        </Header>

        <Content slug={slug} memberships={memberships} />

        <Footer>
          <CancelButton onClick={onClose}>{cancelButtonText}</CancelButton>
          <Button onClick={onSubmit}>{submitButtonText}</Button>
        </Footer>
      </PopupContainer>
    </Modal>;
};

require("./slug_conflict_popup.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./slug_conflict_popup.js");